export default "__VITE_ASSET__9f9713d6__"